/* Presscription delivery calendar. Built from src/, do not edit by hand. */
/* Postcode lists copied verbatim from the previous theme, 21 Sep 2026.
   Fingerprints match the live cart: london fcc948d9e5b2a510, exclude 261b75c0185b1d79, scotland 5e42882faa30ec66. */
window.PDC_LISTS = {"london":["EC1A","EC1M","EC1N","EC1P","EC1R","EC1V","EC1Y","EC2A","EC2M","EC2N","EC2P","EC2R","EC2V","EC2Y","EC3A","EC3M","EC3N","EC3P","EC3R","EC3V","EC4A","EC4M","EC4N","EC4P","EC4R","EC4V","EC4Y","EC1A","EC1M","EC1N","EC1P","EC1R","EC1V","EC1Y","EC2A","EC2M","EC2N","EC2P","EC2R","EC2V","EC2Y","EC3A","EC3M","EC3N","EC3P","EC3R","EC3V","EC4A","EC4M","EC4N","EC4P","EC4R","EC4V","EC4Y","EC50","W1D","W1F","WC1A","WC1B","WC1E","WC1H","WC1N","WC1R","WC1V","WC1X","WC2A","WC2B","WC2E","WC2H","WC2N","WC2R","WC1A","WC1B","WC1E","WC1H","WC1N","WC1R","WC1V","WC1X","WC2A","WC2B","WC2E","WC2H","WC2N","WC2R","E1","E2","E3","E4","E5","E6","E7","E8","E9","E10","E11","E12","E13","E14","E15","E16","E17","E18","E20","E1W","E77","E98","UB2","UB1","UB6","UB5","UB10","UB3","UB11","UB2","UB8","UB7","UB4","UB9","N1","N1 8AF","N2","N3","N4","N5","N6","N7","N8","N9","N10","N11","N12","N13","N14","N15","N16","N17","N18","N19","N20","N21","N22","N1","N1C","N1P","N2","N3","N4","N5","N6","N7","N8","N9","N10","N11","N12","N13","N14","N15","N16","N17","N18","N19","N20","N21","N22","N81","NW1","NW2","NW3","NW4","NW5","NW6","NW7","NW8","NW9","NW10","NW11","NW1","NW1W","NW2","NW3","NW4","NW5","NW6","NW7","NW8","NW9","NW10","NW11","NW26","SE1","SE2","SE3","SE4","SE5","SE6","SE7","SE8","SE9","SE10","SE11","SE12","SE13","SE14","SE15","SE16","SE17","SE18","SE19","SE20","SE21","SE22","SE23","SE24","SE25","SE26","SE27","SE28","SE1","SE1P","SE2","SE3","SE4","SE5","SE6","SE7","SE8","SE9","SE10","SE11","SE12","SE13","SE14","SE15","SE16","SE17","SE18","SE19","SE20","SE21","SE22","SE23","SE24","SE25","SE26","SE27","SE28","SW1","SW2","SW3","SW4","SW5","SW6","SW7","SW8","SW9","SW10","SW11","SW12","SW13","SW14","SW15","SW16","SW17","SW18","SW19","SW20","SW1A","SW1E","SW1H","SW1P","SW1V","SW1W","SW1X","SW1Y","SW2","SW3","SW4","SW5","SW6","SW7","SW8","SW9","SW10","SW11","SW12","SW13","SW14","SW15","SW16","SW17","SW18","SW19","SW20","W1","W2","W3","W4","W5","W6","W7","W8","W9","W10","W11","W12","W13","W14","TW3","W140lh","W1D","W1A","W1B","W1C","W1D","W1F","W1G","W1H","W1J","W1K","W1S","TW9","TW5","TW6","W1T","W1U","W1W","TW1","TW10","TW11","TW13","ha2","WD23","WD6","WD19","WD18","WD17","wD24","WD25","WD7","EN5","EN4","EN2","EN1","EN3","HA8","HA0","HA9","HA7","HA3","HA1","HA2","HA5","TW14","TW8","TW2","TW7","TW4","TW12","KT4","KT5","KT6","KT8","BR1","KT1","BR2","BR3","BR4","BR5","BR6","BR7","BR8","CR0","CR2","CR3","CR4","CR5","CR6","CR7","CR8","DA1","DA14","DA15","DA16","DA17","DA18","DA2","DA5","DA6","DA7","DA8","SM1","SM2","SM3","SM4","SM5","SM6","SM7","EN6","EN7","EN8","EN9","HA4","HA5","HA6","HA7","HA8","HA9","WD3","WD5","IG1","IG10","IG11","IG2","IG3","IG4","IG5","IG6","IG7","IG8","IG9","RM1","RM10","RM11","RM12","RM13","RM15","RM19","RM2","RM3","RM4","RM5","RM6","RM7","RM8","RM9","KT2","KT20","KT21","KT3","KT4","KT7"],"exclude":["AB36","AB37","AB38","AB55","AB56","FK17","FK18","FK19","FK20","FK21","IV1","IV2","IV3","IV4","IV5","IV6","IV7","IV8","IV9","IV10","IV11","IV12","IV13","IV14","IV15","IV16","IV17","IV18","IV19","IV20","IV21","IV22","IV23","IV24","IV25","IV26","IV27","IV28","IV29","IV30","IV31","IV32","IV33","IV34","IV35","IV36","IV37","IV38","IV39","IV52","IV53","IV54","IV63","KW1","KW2","KW3","KW4","KW5","KW6","KW7","KW8","KW9","KW10","KW11","KW12","KW13","KW14","PA21","PA22","PA23","PA24","PA25","PA26","PA27","PA28","PA29","PA30","PA31","PA32","PA33","PA34","PA35","PA36","PA37","PA38","PA39","PA40","PH19","PH20","PH21","PH22","PH23","PH24","PH25","PH26","PH30","PH31","PH32","PH33","PH34","PH35","PH36","PH37","PH38","PH39","PH40","PH41","PH49","PH50","HS1","HS2","HS3","HS4","HS5","HS6","HS7","HS8","HS9","IV40","IV41","IV42","IV43","IV44","IV45","IV46","IV47","IV48","IV49","IV50","IV51","IV55","IV56","KA27","KA28","KW15","KW16","KW17","PA20","PA41","PA42","PA43","PA44","PA45","PA46","PA47","PA48","PA49","PA60","PA61","PA62","PA63","PA64","PA65","PA66","PA67","PA68","PA69","PA70","PA71","PA72","PA73","PA74","PA75","PA76","PA77","PA78","PH42","PH43","PH44","ZE1","ZE2","ZE3","BT","IM","TR21","TR22","TR23","TR24","TR25","AB","KW","PH","HS","ZE","IV","JE","GY"],"scotland":["AB1","AB2","AB23","AB3","AB30","AB31","AB32","AB33","AB34","AB35","AB41","AB42","AB43","AB44","AB45","AB51","AB52","AB53","AB54","DD1","DD10","DD11","DD2","DD3","DD4","DD5","DD6","DD7","DD8","DD9","DG1","DG10","DG11","DG12","DG13","DG14","DG16","DG2","DG3","DG4","DG5","DG6","DG7","DG8","DG9","EH1","EH10","EH12","EH13","EH14","EH15","EH16","EH17","EH18","EH19","EH2","EH20","EH21","EH22","EH23","EH24","EH25","EH26","EH27","EH28","EH29","EH3","EH30","EH31","EH32","EH33","EH34","EH35","EH36","EH37","EH38","EH39","EH4","EH40","EH41","EH42","EH43","EH44","EH45","EH46","EH47","EH48","EH49","EH5","EH52","EH53","EH54","EH55","EH6","EH7","EH8","EH9","FK1","FK10","FK11","FK12","FK13","FK14","FK15","FK16","FK2","FK3","FK4","FK5","FK6","FK7","FK8","FK9","G1","G11","G12","G14","G15","G2","G20","G21","G3","G31","G32","G33","G4","G40","G41","G42","G43","G45","G46","G5","G51","G53","G60","G61","G62","G63","G64","G65","G66","G67","G68","G69","G71","G72","G73","G74","G75","G76","G77","G78","G81","G82","G83","G84","G9","KA1","KA10","KA11","KA12","KA13","KA14","KA15","KA16","KA17","KA18","KA19","KA2","KA20","KA21","KA22","KA23","KA24","KA25","KA26","KA29","KA3","KA30","KA4","KA5","KA6","KA7","KA8","KA9","KY1","KY10","KY11","KY12","KY13","KY14","KY15","KY16","KY2","KY3","KY4","KY5","KY6","KY7","KY8","KY9","ML1","ML10","ML11","ML12","ML2","ML3","ML4","ML5","ML6","ML7","ML8","ML9","PA1","PA10","PA11","PA12","PA13","PA14","PA15","PA16","PA17","PA18","PA19","PA3","PA4","PA5","PA6","PA7","PA8","PA9","PH1","PH10","PH11","PH12","PH13","PH14","PH15","PH16","PH17","PH18","PH2","PH3","PH4","PH5","PH6","PH7","PH8","PH9","TD1","TD10","TD11","TD12","TD13","TD14","TD15","TD2","TD3","TD4","TD5","TD6","TD7","TD8","TD9"]};

/*
 * Presscription delivery calendar: the rules.
 *
 * Pure logic, no DOM. Works in calendar dates ('YYYY-MM-DD') throughout, so
 * no timezone or daylight saving change can move a delivery day. The live
 * theme got the same answers through clock arithmetic that happened to land
 * on the right day; this states them directly.
 *
 * Defaults reproduce the live cart exactly. Every departure from live is a
 * named setting that is off unless switched on.
 */
var PDCEngine = (function () {
  'use strict';

  var DAY = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MONTH = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
               'August', 'September', 'October', 'November', 'December'];

  /* the format check the live cart uses, from jquery-validation's postcodeUK */
  var UK_POSTCODE = /^((([A-PR-UWYZ][0-9])|([A-PR-UWYZ][0-9][0-9])|([A-PR-UWYZ][A-HK-Y][0-9])|([A-PR-UWYZ][A-HK-Y][0-9][0-9])|([A-PR-UWYZ][0-9][A-HJKSTUW])|([A-PR-UWYZ][A-HK-Y][0-9][ABEHMNPRVWXY]))\s?([0-9][ABD-HJLNP-UW-Z]{2})|(GIR)\s?(0AA))$/i;

  /* ---------------------------------------------------------- dates */

  function parse(ymd) {
    var p = String(ymd).split('-');
    return Date.UTC(+p[0], +p[1] - 1, +p[2]);
  }
  function fmt(ms) {
    var d = new Date(ms);
    return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate());
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function addDays(ymd, n) { return fmt(parse(ymd) + n * 86400000); }
  function weekday(ymd) { return new Date(parse(ymd)).getUTCDay(); }
  function addMonths(ymd, n) {
    var d = new Date(parse(ymd));
    var y = d.getUTCFullYear(), m = d.getUTCMonth() + n, day = d.getUTCDate();
    var dim = new Date(Date.UTC(y, m + 1, 0)).getUTCDate();
    return fmt(Date.UTC(y, m, Math.min(day, dim)));
  }
  function todayLocal(now) {
    now = now || new Date();
    return now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate());
  }

  /* "Tuesday, September 29TH, 2026", exactly as the live cart prints it */
  function ordinal(n) {
    var last = n % 10, tens = Math.floor(n / 10) % 10;
    if (tens !== 1 && last === 1) return n + 'ST';
    if (tens !== 1 && last === 2) return n + 'ND';
    if (tens !== 1 && last === 3) return n + 'RD';
    return n + 'TH';
  }
  function describe(ymd) {
    var d = new Date(parse(ymd));
    return DAY[d.getUTCDay()] + ', ' + MONTH[d.getUTCMonth()] + ' ' +
           ordinal(d.getUTCDate()) + ', ' + d.getUTCFullYear();
  }

  /* -------------------------------------------------------- defaults */

  var DEFAULTS = {
    /* How the LONDON list is matched. 'prefix' is live: 'KT1' also catches
       KT12 and KT22. 'outward' matches the district before the space
       exactly. The exclude and Scotland lists always match by prefix,
       because they were written that way: 'AB1' there means AB10 to AB16. */
    londonMatch: 'prefix',
    lists: { london: [], exclude: [], scotland: [] },
    londonAdd: [], londonRemove: [], excludeRemove: [],
    blocked: [],       /* no delivery on these dates, anywhere */
    blockedDpd: [],    /* no delivery on these dates outside London */
    minDays: 2,
    maxMonths: 3,
    /* weekdays a cleanse may START on, 0 = Sunday */
    startDays: { london: [1, 2, 3, 4, 5], outside: [2, 3, 4, 5] },
    /* London's first box arrives the evening before the start date */
    londonEveBefore: true,
    /* extra boxes, as days after the FIRST box, keyed by the weekday the
       first box arrives. These are what live shows customers. */
    drops: {
      london:  { seven: { 0: [2, 4], 1: [3, 6], 2: [2, 5], 3: [1, 4], 4: [3, 5] },
                 five:  { 0: [3], 1: [3], 2: [2], 3: [1, 4], 4: [3] } },
      outside: { seven: {},
                 five:  { 2: [3], 3: [2] } }
    },
    sevenDayLondonOnly: true
  };

  function merge(base, over) {
    var out = {};
    for (var k in base) out[k] = base[k];
    for (var j in (over || {})) if (over[j] !== undefined && over[j] !== null) out[j] = over[j];
    return out;
  }
  function upper(list) {
    var out = [];
    for (var i = 0; i < (list || []).length; i++) {
      var v = String(list[i]).trim();
      if (v) out.push(v.toUpperCase());
    }
    return out;
  }
  function without(list, remove) {
    var r = upper(remove), out = [];
    for (var i = 0; i < list.length; i++) {
      if (r.indexOf(String(list[i]).toUpperCase()) === -1) out.push(list[i]);
    }
    return out;
  }

  /* ---------------------------------------------------------- engine */

  function create(config) {
    var c = merge(DEFAULTS, config);
    var lists = {
      london: without(c.lists.london.concat(upper(c.londonAdd)), c.londonRemove),
      exclude: without(c.lists.exclude, c.excludeRemove),
      scotland: c.lists.scotland.slice()
    };

    /* live: postcode.toLowerCase().match("^" + entry.toLowerCase()) */
    function prefixHit(pc, list) {
      var p = pc.toLowerCase();
      for (var i = 0; i < list.length; i++) {
        if (p.match('^' + String(list[i]).toLowerCase())) return true;
      }
      return false;
    }

    function parts(pc) {
      var full = String(pc).toUpperCase().replace(/\s+/g, '');
      var outward = UK_POSTCODE.test(pc) && full.length > 3 ? full.slice(0, -3) : full;
      var area = (outward.match(/^[A-Z]+/) || [''])[0];
      return { full: full, outward: outward, area: area };
    }
    function outwardHit(pc, list) {
      var p = parts(pc);
      for (var i = 0; i < list.length; i++) {
        var e = String(list[i]).toUpperCase().replace(/\s+/g, '');
        if (e === p.outward) return true;                 /* district, SW1A */
        if (/^[A-Z]+$/.test(e) && e === p.area) return true;  /* whole area, BT */
        if (e.length > p.outward.length && e === p.full) return true;  /* one address */
      }
      return false;
    }
    var londonHit = c.londonMatch === 'outward' ? outwardHit : prefixHit;

    function isValidPostcode(pc) { return UK_POSTCODE.test(String(pc || '').trim()); }

    /* excluded first, then London, then Scotland, then the rest: live order */
    function classify(pc) {
      pc = String(pc || '').trim();
      if (!isValidPostcode(pc)) return { zone: 'invalid', london: false };
      if (prefixHit(pc, lists.exclude)) return { zone: 'excluded', london: false };
      if (londonHit(pc, lists.london)) return { zone: 'london', london: true };
      if (prefixHit(pc, lists.scotland)) return { zone: 'scotland', london: false };
      return { zone: 'uk', london: false };
    }

    function bounds(today) {
      return { min: addDays(today, c.minDays), max: addMonths(today, c.maxMonths) };
    }

    function isSelectable(ymd, zone, today) {
      if (zone === 'excluded' || zone === 'invalid') return false;
      var b = bounds(today);
      if (ymd < b.min || ymd > b.max) return false;
      var wd = weekday(ymd);
      var days = zone === 'london' ? c.startDays.london : c.startDays.outside;
      if (days.indexOf(wd) === -1) return false;
      if (c.blocked.indexOf(ymd) !== -1) return false;
      if (zone !== 'london' && c.blockedDpd.indexOf(ymd) !== -1) return false;
      return true;
    }

    /* what is in the basket, from /cart.js items */
    function cartKind(items) {
      var seven = false, five = false;
      for (var i = 0; i < (items || []).length; i++) {
        var it = items[i];
        var v = String(it.variant_title || ''), p = String(it.product_title || '');
        if (/^7 [Dd]/.test(v) || /7 [Dd]/.test(p)) seven = true;
        if (/^5 [Dd]/.test(v)) five = true;
      }
      return { seven: seven, five: five };
    }

    /* the delivery plan for a chosen start date */
    function plan(start, zone, kind) {
      var london = zone === 'london';
      var first = london && c.londonEveBefore ? addDays(start, -1) : start;
      var table = c.drops[london ? 'london' : 'outside'];
      var extra = [];
      if (kind && kind.seven) extra = table.seven[weekday(first)] || [];
      else if (kind && kind.five) extra = table.five[weekday(first)] || [];
      var drops = [first];
      for (var i = 0; i < extra.length; i++) drops.push(addDays(first, extra[i]));
      var s = start.split('-');
      return {
        drops: drops,
        lines: drops.map(describe),
        text: drops.map(describe).join(' and<br>'),
        start_date: s[2] + '/' + s[1] + '/' + s[0],      /* dd/mm/yyyy, as live */
        day_of_week: DAY[weekday(start)]
      };
    }

    function checkoutBlock(zone, kind) {
      /* 22 SEP 2026: only once a postcode has been placed. With no postcode yet
         the customer is asked for one, not told to get in touch. */
      if (!zone || zone === 'excluded' || zone === 'invalid') return null;
      if (c.sevenDayLondonOnly && kind && kind.seven && zone !== 'london') return 'seven_outside_london';
      return null;
    }

    /* attributes for the cart, names and formats exactly as live */
    function attributes(pc, zone) {
      return {
        postcode: String(pc || '').trim(),
        is_london: zone === 'london' ? 'YES' : (zone === 'excluded' ? '' : 'NO')
      };
    }

    return {
      config: c, lists: lists,
      isValidPostcode: isValidPostcode, classify: classify, bounds: bounds,
      isSelectable: isSelectable, cartKind: cartKind, plan: plan,
      checkoutBlock: checkoutBlock, attributes: attributes
    };
  }

  return {
    create: create, DEFAULTS: DEFAULTS, UK_POSTCODE: UK_POSTCODE,
    addDays: addDays, addMonths: addMonths, weekday: weekday, describe: describe,
    todayLocal: todayLocal, DAY: DAY, MONTH: MONTH
  };
})();

if (typeof module !== 'undefined' && module.exports) module.exports = PDCEngine;

/*
 * Presscription delivery calendar: the cart block and the checkout guard.
 *
 * Loaded on every page. Where the cart block is present it runs the
 * calendar; everywhere else it only guards checkout, sending anything that
 * heads for checkout to the cart page first, because that is the only place
 * a delivery date can be chosen.
 */
(function () {
  'use strict';

  var E = window.PDCEngine;
  var CFG = window.PDC_CONFIG || {};
  if (!E || CFG.enabled === false) return;

  var ROOT_URL = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CART_URL = CFG.cartUrl || (ROOT_URL + 'cart');
  var T = CFG.text || {};

  /* ------------------------------------------------------ settings in */

  function parseDates(text) {
    var out = [];
    String(text || '').split(/[\n,;]+/).forEach(function (raw) {
      var s = raw.trim();
      if (!s) return;
      var range = s.split(/\s+to\s+/i);
      var a = one(range[0]), b = range[1] ? one(range[1]) : a;
      if (!a || !b) return;
      for (var d = a; d <= b; d = E.addDays(d, 1)) out.push(d);
    });
    return out;
    function one(v) {
      v = String(v).trim();
      var m = v.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
      if (m) return m[1] + '-' + p2(m[2]) + '-' + p2(m[3]);
      m = v.match(/^(\d{1,2})[\/.\-](\d{1,2})[\/.\-](\d{4})$/);
      if (m) return m[3] + '-' + p2(m[2]) + '-' + p2(m[1]);
      return null;
    }
    function p2(n) { return (n.length < 2 ? '0' : '') + n; }
  }
  function parseList(text) {
    return String(text || '').split(/[\s,;]+/).map(function (s) { return s.trim(); }).filter(Boolean);
  }

  var engine = E.create({
    londonMatch: CFG.matchMode === 'outward' ? 'outward' : 'prefix',
    lists: window.PDC_LISTS,
    londonAdd: parseList(CFG.londonAdd),
    londonRemove: parseList(CFG.londonRemove),
    excludeRemove: CFG.deliverAbPh ? ['AB', 'PH'] : [],
    blocked: parseDates(CFG.blocked),
    blockedDpd: parseDates(CFG.blockedDpd),
    sevenDayLondonOnly: CFG.sevenDayLondonOnly !== false
  });

  /* today in the UK, whatever clock the customer's device is on */
  function today() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London',
        year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (p) { o[p.type] = p.value; });
      return o.year + '-' + o.month + '-' + o.day;
    } catch (e) { return E.todayLocal(); }
  }

  /* --------------------------------------------------------- cart API */

  var queue = Promise.resolve();
  function request(path, body) {
    var opts = { headers: { 'Accept': 'application/json', 'X-PDC': '1' }, credentials: 'same-origin' };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(ROOT_URL + path.replace(/^\//, ''), opts).then(function (r) {
      if (!r.ok) throw new Error(path + ' ' + r.status);
      return r.json();
    });
  }
  function getCart() { return request('cart.js'); }
  /* writes go through one queue so they land in the order they were made */
  function saveAttributes(attrs) {
    queue = queue.then(function () { return request('cart/update.js', { attributes: attrs }); })
                 .catch(function (e) { state.saveFailed = true; throw e; });
    return queue;
  }

  /* ----------------------------------------------------- express pay */

  if (CFG.hideExpress !== false) {
    var st = document.createElement('style');
    st.textContent =
      '.shopify-payment-button,shopify-accelerated-checkout,shopify-accelerated-checkout-cart,' +
      '.additional-checkout-buttons,.dynamic-checkout__content,[data-shopify="payment-button"],' +
      '[data-shopify-buttoncontainer]{display:none!important}';
    document.head.appendChild(st);
  }

  /* ------------------------------------------------ checkout detection */

  var CHECKOUT_SEL = '[name="checkout"],a[href$="/checkout"],a[href*="/checkout?"],' +
                     'a[href*="/checkouts/"],[data-pdc-checkout]';
  function checkoutTarget(el) {
    return el && el.closest ? el.closest(CHECKOUT_SEL) : null;
  }
  function formGoesToCheckout(form, submitter) {
    var action = form.getAttribute('action') || '';
    if (/\/checkout/.test(action)) return true;
    return !!(submitter && submitter.name === 'checkout');
  }

  var root = document.querySelector('[data-pdc]');

  /* no calendar on this page: anything heading for checkout goes to the cart */
  if (!root) {
    document.addEventListener('click', function (e) {
      var t = checkoutTarget(e.target);
      if (!t) return;
      e.preventDefault(); e.stopImmediatePropagation();
      window.location.href = CART_URL;
    }, true);
    document.addEventListener('submit', function (e) {
      if (!formGoesToCheckout(e.target, e.submitter)) return;
      e.preventDefault(); e.stopImmediatePropagation();
      window.location.href = CART_URL;
    }, true);
    return;
  }

  /* =================================================== the cart block */

  var state = {
    postcode: '', zone: null, date: null, plan: null, confirmed: false,
    kind: { seven: false, five: false }, items: [], total: 0,
    passing: false, saveFailed: false, month: null
  };

  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    for (var k in (attrs || {})) {
      if (k === 'text') n.textContent = attrs[k];
      else if (k === 'html') n.innerHTML = attrs[k];
      else n.setAttribute(k, attrs[k]);
    }
    (kids || []).forEach(function (c) { if (c) n.appendChild(c); });
    return n;
  }
  function show(n, on) { n.hidden = !on; }

  /* ---------------------------------------------------------- build */

  var ICON = {
    pin: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22s7-6.2 7-12a7 7 0 0 0-14 0c0 5.8 7 12 7 12z"/><circle cx="12" cy="10" r="2.6"/></svg>',
    van: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h11v10H3z"/><path d="M14 9h4l3 3.5V16h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/></svg>',
    info: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 7.5h.01"/></svg>',
    prev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>',
    next: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>'
  };
  var SHORT_DAY = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var SHORT_MONTH = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function shortDate(ymd) {
    var wd = E.weekday(ymd), p = ymd.split('-');
    return SHORT_DAY[wd] + ' ' + (+p[2]) + ' ' + SHORT_MONTH[+p[1] - 1];
  }
  function longDate(ymd) {
    var wd = E.weekday(ymd), p = ymd.split('-');
    return E.DAY[wd] + ' ' + (+p[2]) + ' ' + E.MONTH[+p[1] - 1] + ' ' + p[0];
  }
  function stepLabel(n, text, forId) {
    var lab = el(forId ? 'label' : 'p', { 'class': 'pdc-label' });
    if (forId) lab.setAttribute('for', forId);
    lab.appendChild(el('span', { 'class': 'pdc-num', 'aria-hidden': 'true', text: String(n) }));
    lab.appendChild(el('span', { text: text }));
    return lab;
  }

  var ui = {};
  ui.errors = el('div', { 'class': 'pdc-errors', role: 'alert', hidden: '' });
  ui.input = el('input', { 'class': 'pdc-input', id: 'pdc-postcode', type: 'text',
    autocomplete: 'postal-code', autocapitalize: 'characters', spellcheck: 'false',
    placeholder: T.placeholder || 'e.g. SW1A 1AA', 'aria-describedby': 'pdc-postcode-msg' });
  ui.inputMsg = el('p', { 'class': 'pdc-field-msg', id: 'pdc-postcode-msg', 'aria-live': 'polite' });
  ui.zone = el('p', { 'class': 'pdc-zone', hidden: '', 'aria-live': 'polite' });
  ui.excluded = el('div', { 'class': 'pdc-notice', hidden: '' }, [
    el('span', { 'class': 'pdc-ico', html: ICON.info }), el('p', { text: T.excluded })
  ]);
  ui.cal = el('div', { 'class': 'pdc-cal' });
  ui.calWrap = el('div', { 'class': 'pdc-step', hidden: '' }, [
    stepLabel(2, T.step2),
    ui.cal,
    el('p', { 'class': 'pdc-hint', text: T.note })
  ]);
  ui.drops = el('ol', { 'class': 'pdc-drops' });
  ui.planNote = el('p', { 'class': 'pdc-plan-note' });
  ui.confirm = el('input', { type: 'checkbox', id: 'pdc-confirm' });
  ui.arrival = el('div', { 'class': 'pdc-plan', hidden: '', 'aria-live': 'polite' }, [
    el('p', { 'class': 'pdc-plan-h' }, [el('span', { 'class': 'pdc-ico', html: ICON.van }), el('span', { text: T.planTitle || 'Your delivery' })]),
    ui.drops, ui.planNote,
    ui.confirmRow = el('label', { 'class': 'pdc-confirm', 'for': 'pdc-confirm' }, [ui.confirm, el('span', { text: T.confirm })])
  ]);

  /* shown beside the calendar, where the plan will appear, when there is
     room for two columns */
  ui.planEmpty = el('div', { 'class': 'pdc-plan-empty' }, [
    el('span', { 'class': 'pdc-ico', html: ICON.van }),
    el('p', { text: T.planEmpty || 'Pick a start date to see when each box arrives.' })
  ]);

  root.innerHTML = '';
  root.appendChild(el('div', { 'class': 'pdc' }, [
    el('p', { 'class': 'pdc-title', text: T.title }),
    el('div', { 'class': 'pdc-cols' }, [
      el('div', { 'class': 'pdc-col' }, [
        el('div', { 'class': 'pdc-step' }, [
          stepLabel(1, T.step1, 'pdc-postcode'),
          el('div', { 'class': 'pdc-field' }, [el('span', { 'class': 'pdc-ico', html: ICON.pin }), ui.input]),
          ui.inputMsg, ui.zone
        ]),
        ui.excluded, ui.calWrap
      ]),
      /* an empty slot the cart page can move its order note into, so the
         note sits beside the postcode and the plan beside the calendar */
      el('div', { 'class': 'pdc-col' }, [
        ui.noteSlot = el('div', { 'class': 'pdc-note-slot', 'data-pdc-slot': 'note' }),
        ui.planEmpty, ui.arrival, ui.errors
      ])
    ])
  ]));

  /* the 7 day popup lives at the end of body so no container clips it */
  ui.modal = el('div', { 'class': 'pdc-modal', hidden: '', role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'pdc-modal-title' }, [
    el('div', { 'class': 'pdc-modal-box' }, [
      el('h2', { id: 'pdc-modal-title', text: T.popupTitle }),
      el('p', { text: T.popupBody }),
      el('div', { 'class': 'pdc-modal-actions' }, [
        ui.removeBtn = el('button', { type: 'button', 'class': 'pdc-btn', text: T.popupRemove }),
        ui.changeBtn = el('button', { type: 'button', 'class': 'pdc-btn pdc-btn-alt', text: T.popupChange })
      ])
    ])
  ]);
  document.body.appendChild(ui.modal);
  /* tells the page the block is built, so it can fill the note slot */
  root.dispatchEvent(new CustomEvent('pdc:ready', { bubbles: true }));

  /* -------------------------------------------------------- render */

  function renderZone() {
    var z = state.zone, label = '';
    if (z === 'london') label = T.zoneLondon;
    else if (z === 'uk') label = T.zoneUk;
    else if (z === 'scotland') label = T.zoneScotland;
    ui.zone.innerHTML = '';
    if (label) {
      ui.zone.className = 'pdc-zone pdc-zone--' + z;
      ui.zone.appendChild(el('span', { 'class': 'pdc-ico', html: ICON.van }));
      ui.zone.appendChild(el('span', { text: label }));
    }
    show(ui.zone, !!label);
  }

  /* Monday first, as a UK calendar should be */
  function renderCalendar() {
    var t = today(), b = engine.bounds(t);
    if (!state.month) state.month = (state.date || b.min).slice(0, 7);
    var y = +state.month.slice(0, 4), m = +state.month.slice(5, 7) - 1;
    var first = y + '-' + (m < 9 ? '0' : '') + (m + 1) + '-01';
    var lead = (E.weekday(first) + 6) % 7;
    var dim = new Date(Date.UTC(y, m + 1, 0)).getUTCDate();

    var prev = el('button', { type: 'button', 'class': 'pdc-nav', 'aria-label': 'Previous month', html: ICON.prev });
    var next = el('button', { type: 'button', 'class': 'pdc-nav', 'aria-label': 'Next month', html: ICON.next });
    if (state.month <= b.min.slice(0, 7)) prev.disabled = true;
    if (state.month >= b.max.slice(0, 7)) next.disabled = true;
    prev.onclick = function () { state.month = shiftMonth(state.month, -1); renderCalendar(); };
    next.onclick = function () { state.month = shiftMonth(state.month, 1); renderCalendar(); };

    var grid = el('div', { 'class': 'pdc-grid' });
    ['M', 'T', 'W', 'T', 'F', 'S', 'S'].forEach(function (d) {
      grid.appendChild(el('span', { 'class': 'pdc-dow', 'aria-hidden': 'true', text: d }));
    });
    /* In the month that holds the first bookable date, start at that week:
       whole rows of greyed out past days are noise. */
    var startDay = 1;
    if (state.month === b.min.slice(0, 7)) {
      var minDay = +b.min.slice(8, 10);
      startDay = minDay - ((E.weekday(b.min) + 6) % 7);
      if (startDay < 1) startDay = 1;
    }
    if (startDay === 1) for (var i = 0; i < lead; i++) grid.appendChild(el('span', { 'class': 'pdc-blank' }));
    for (var d = startDay; d <= dim; d++) {
      var key = first.slice(0, 8) + (d < 10 ? '0' : '') + d;
      var ok = engine.isSelectable(key, state.zone, t);
      var btn = el('button', { type: 'button', 'class': 'pdc-day', 'data-date': key,
        'aria-label': longDate(key), text: String(d) });
      if (!ok) btn.disabled = true;
      if (key === state.date) { btn.classList.add('is-selected'); btn.setAttribute('aria-pressed', 'true'); }
      btn.onclick = pick;
      grid.appendChild(btn);
    }
    ui.cal.innerHTML = '';
    ui.cal.appendChild(el('div', { 'class': 'pdc-cal-head' }, [
      prev, el('span', { 'class': 'pdc-month', 'aria-live': 'polite', text: E.MONTH[m] + ' ' + y }), next
    ]));
    ui.cal.appendChild(grid);
  }
  function shiftMonth(ym, n) {
    var y = +ym.slice(0, 4), m = +ym.slice(5, 7) - 1 + n;
    y += Math.floor(m / 12); m = ((m % 12) + 12) % 12;
    return y + '-' + (m < 9 ? '0' : '') + (m + 1);
  }

  function renderArrival() {
    show(ui.planEmpty, !(state.date && state.plan) && state.zone !== 'excluded');
    if (!state.date || !state.plan) { show(ui.arrival, false); return; }
    var z = state.zone;
    var slot = z === 'london' ? T.slotLondon : (z === 'uk' ? T.slotUk : T.slotScotland);
    ui.drops.innerHTML = '';
    var many = state.plan.drops.length > 1;
    state.plan.drops.forEach(function (ymd, i) {
      var li = el('li', { 'class': 'pdc-drop', 'data-date': ymd });
      if (many) li.appendChild(el('span', { 'class': 'pdc-drop-n', text: (T.boxWord || 'Box') + ' ' + (i + 1) }));
      li.appendChild(el('span', { 'class': 'pdc-drop-day', text: shortDate(ymd) }));
      if (slot) li.appendChild(el('span', { 'class': 'pdc-drop-slot', text: slot }));
      ui.drops.appendChild(li);
    });
    ui.planNote.textContent = z === 'london' ? T.planNoteLondon : T.planNoteOther;
    show(ui.planNote, !!ui.planNote.textContent);
    ui.confirm.checked = state.confirmed;
    show(ui.arrival, true);
  }

  function clearFlags() {
    [].forEach.call(root.querySelectorAll('.pdc-flag'), function (n) { n.classList.remove('pdc-flag'); });
  }
  function showErrors(list) {
    ui.errors.innerHTML = '';
    clearFlags();
    if (!list.length) { show(ui.errors, false); return; }
    list = list.map(function (x) { return typeof x === 'string' ? { m: x } : x; });
    var ul = el('ul');
    list.forEach(function (x) { ul.appendChild(el('li', { text: x.m })); });
    ui.errors.appendChild(ul);
    show(ui.errors, true);
    /* take the customer to the first thing to fix, in the middle of the
       screen so a sticky header can never cover it, and mark it */
    var first = list[0], target = first.at || ui.errors;
    target.classList.add('pdc-flag');
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (first.focus) { try { first.focus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ------------------------------------------------------- postcode */

  function applyPostcode(save) {
    var raw = ui.input.value.trim();
    if (!raw) { resetZone(); return; }
    if (!engine.isValidPostcode(raw)) {
      ui.inputMsg.textContent = raw.length >= 5 ? T.invalid : '';
      resetZone();
      return;
    }
    ui.inputMsg.textContent = '';
    var changed = raw.toUpperCase().replace(/\s+/g, '') !== state.postcode.toUpperCase().replace(/\s+/g, '');
    /* Nothing new: leave the calendar alone. Rebuilding it here would destroy
       the day button a customer is in the middle of tapping, because leaving
       this field (blur) fires between pressing a date and releasing it. */
    if (!changed && state.zone) return;
    state.postcode = raw;
    state.zone = engine.classify(raw).zone;

    if (changed && state.date) {
      /* a date chosen for one address does not carry to another */
      state.date = null; state.plan = null; state.confirmed = false;
      if (save) saveAttributes({ start_date: '', day_of_week: '' });
    }
    if (save) saveAttributes(engine.attributes(raw, state.zone));

    renderZone();
    show(ui.excluded, state.zone === 'excluded');
    show(ui.calWrap, state.zone !== 'excluded');
    state.month = null;
    renderCalendar();
    renderArrival();
    showErrors([]);
    maybeSevenDayBlock();
  }
  function resetZone() {
    state.zone = null;
    renderZone();
    show(ui.excluded, false); show(ui.calWrap, false); show(ui.arrival, false);
  }

  /* ----------------------------------------------------------- date */

  function pick(e) {
    var key = e.currentTarget.getAttribute('data-date');
    state.date = key;
    state.plan = engine.plan(key, state.zone, state.kind);
    state.confirmed = false;
    saveAttributes({ start_date: state.plan.start_date, day_of_week: state.plan.day_of_week });
    renderCalendar();
    renderArrival();
    showErrors([]);
  }

  /* ---------------------------------------------------------- 7 day */

  function maybeSevenDayBlock() {
    if (!state.zone || state.zone === 'excluded') return false;
    if (engine.checkoutBlock(state.zone, state.kind)) { openModal(); return true; }
    return false;
  }
  function openModal() { ui.modal.hidden = false; ui.removeBtn.disabled = false; ui.removeBtn.focus(); }
  function closeModal() { ui.modal.hidden = true; }

  ui.changeBtn.onclick = function () { closeModal(); ui.input.focus(); ui.input.select(); };
  ui.removeBtn.onclick = function () {
    ui.removeBtn.disabled = true;
    getCart().then(function (cart) {
      var lines = cart.items.filter(function (it) { return engine.cartKind([it]).seven; });
      return lines.reduce(function (p, it) {
        return p.then(function () { return request('cart/change.js', { id: it.key, quantity: 0 }); });
      }, Promise.resolve());
    }).then(getCart).then(function (cart) {
      var min = CFG.minimumAfterRemove == null ? 3500 : CFG.minimumAfterRemove;
      window.location.href = cart.total_price < min ? (CFG.belowMinimumUrl || ROOT_URL + 'collections/all') : CART_URL;
    }).catch(function () { ui.removeBtn.disabled = false; });
  };

  /* ------------------------------------------------ the basket itself */

  function readCart(cart) {
    state.items = cart.items || [];
    state.total = cart.total_price || 0;
    var before = JSON.stringify(state.kind);
    state.kind = engine.cartKind(state.items);
    if (state.date && JSON.stringify(state.kind) !== before) {
      state.plan = engine.plan(state.date, state.zone, state.kind);
      renderArrival();
    }
    return cart;
  }

  /* notice basket changes made by the theme, not by this script */
  if (window.fetch && !window.fetch.__pdc) {
    var realFetch = window.fetch;
    var wrapped = function (input, init) {
      var p = realFetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var mine = init && init.headers && (init.headers['X-PDC'] || (init.headers.get && init.headers.get('X-PDC')));
        if (!mine && /\/cart\/(add|change|update|clear)/.test(url)) {
          p.then(function () { return getCart().then(readCart).then(maybeSevenDayBlock); }).catch(function () {});
        }
      } catch (e) { /* never break the theme's own request */ }
      return p;
    };
    wrapped.__pdc = true;
    window.fetch = wrapped;
  }

  /* -------------------------------------------------------- checkout */

  /* each problem carries the part of the block that needs fixing */
  function problems() {
    var out = [];
    if (!state.postcode || !engine.isValidPostcode(state.postcode)) out.push({ m: T.errPostcode, at: ui.input.parentNode, focus: ui.input });
    else if (state.zone === 'excluded') out.push({ m: T.excluded, at: ui.excluded });
    if (!state.date && state.zone !== 'excluded') out.push({ m: T.errDate, at: ui.cal });
    if (state.date && !state.confirmed) out.push({ m: T.errConfirm, at: ui.confirmRow, focus: ui.confirm });
    return out;
  }

  function go(trigger, form) {
    state.passing = true;
    setTimeout(function () { state.passing = false; }, 5000);
    if (trigger && trigger.tagName === 'A') { window.location.href = trigger.href; return; }
    form = form || (trigger && (trigger.form || trigger.closest('form')));
    if (form) {
      if (form.requestSubmit) form.requestSubmit(trigger && trigger.type === 'submit' ? trigger : undefined);
      else form.submit();
      return;
    }
    if (trigger) trigger.click(); else window.location.href = ROOT_URL + 'checkout';
  }

  function gate(e, trigger, form) {
    if (state.passing) return;
    e.preventDefault(); e.stopImmediatePropagation();
    getCart().then(readCart).then(function () {
      /* a date that has since gone out of range cannot be used */
      if (state.date && !engine.isSelectable(state.date, state.zone, today())) {
        state.date = null; state.plan = null; state.confirmed = false;
        renderCalendar(); renderArrival();
      }
      if (maybeSevenDayBlock()) return;
      var list = problems();
      if (list.length) { showErrors(list); return; }
      /* make sure what the order will carry is what the customer chose */
      return queue.then(getCart).then(function (cart) {
        var want = engine.attributes(state.postcode, state.zone);
        want.start_date = state.plan.start_date;
        want.day_of_week = state.plan.day_of_week;
        var a = cart.attributes || {}, stale = false;
        for (var k in want) if ((a[k] || '') !== want[k]) stale = true;
        return stale ? request('cart/update.js', { attributes: want }) : cart;
      }).then(function () { go(trigger, form); });
    }).catch(function () { showErrors([T.errSave]); });
  }

  document.addEventListener('click', function (e) {
    var t = checkoutTarget(e.target);
    if (t) gate(e, t, null);
  }, true);
  document.addEventListener('submit', function (e) {
    if (formGoesToCheckout(e.target, e.submitter)) gate(e, e.submitter || null, e.target);
  }, true);

  /* ---------------------------------------------------------- inputs */

  ui.input.addEventListener('input', function () {
    var v = ui.input.value.trim();
    if (v.length >= 5 && engine.isValidPostcode(v)) applyPostcode(true);
    else if (!v) resetZone();
  });
  ui.input.addEventListener('blur', function () { applyPostcode(true); });
  ui.input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); applyPostcode(true); }
  });
  ui.confirm.addEventListener('change', function () {
    state.confirmed = ui.confirm.checked;
    if (state.confirmed) showErrors([]);
  });
  ui.modal.addEventListener('keydown', function (e) { if (e.key === 'Escape') ui.changeBtn.click(); });

  /* ----------------------------------------------------------- start */

  getCart().then(readCart).then(function (cart) {
    var a = cart.attributes || {};
    if (a.postcode && engine.isValidPostcode(a.postcode)) {
      ui.input.value = a.postcode;
      state.postcode = a.postcode;
      state.zone = engine.classify(a.postcode).zone;
      /* bring back a date chosen earlier, but only if it can still be chosen */
      var m = String(a.start_date || '').match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (m) {
        var key = m[3] + '-' + m[2] + '-' + m[1];
        if (engine.isSelectable(key, state.zone, today())) {
          state.date = key;
          state.plan = engine.plan(key, state.zone, state.kind);
        } else {
          saveAttributes({ start_date: '', day_of_week: '' });
        }
      }
      renderZone();
      show(ui.excluded, state.zone === 'excluded');
      show(ui.calWrap, state.zone !== 'excluded');
      renderCalendar();
      renderArrival();
      setTimeout(maybeSevenDayBlock, 600);
    }
  }).catch(function () { /* the block still works, it just starts empty */ });

  window.PDC = { engine: engine, state: state, today: today };
})();
